import {authRequest} from './index.js'
import axios from 'axios'; // New import
import { swalError } from '@/helper'; // New import

export async function get_materials_filter(params = {type: 'module'}){
  let data
  await authRequest.get(
    '/materials',
    {
      params
    } 
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_materials(type){
  let data
  await authRequest.get(
    '/materials/' + type
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_material(material_id){
  let data
  await authRequest.get(
    '/materials/' + material_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_reading_materials(material_id){
  let data
  await authRequest.get(
    '/materials/' + material_id + '/reading_material'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function create_material(material){
  let data
  let payload = material instanceof FormData ? material : { material }
  await authRequest.post(
    '/materials',
    payload
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error}
  })
  return data
}

export async function create_material_bulk(material){
  let data
  await authRequest.post(
    '/materials/bulk',
    { material }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function getPresignedUrl(filename, contentType){
  let data
  await authRequest.post(
    '/materials/presigned_url', // Corrected path to admin namespace
    { filename, content_type: contentType }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_material(material){
  let data
  let payload
  let headers = {}
  
  if (material instanceof FormData) {
    payload = material
    // Let browser set content type with boundary for FormData
  } else {
    payload = { material }
    headers['Content-Type'] = 'multipart/form-data' // This might have been wrong for JSON but keeping as legacy path if needed
  }

  // Extract ID from FormData or Object
  let id
  if (material instanceof FormData) {
    // Assuming you append 'id' to formData or pass it separately? 
    // Usually UPDATE needs ID in URL.
    // We'll assume the caller handles this or we extract it.
    // But FormData.get('id') works.
    id = material.get('id') || material.get('material[id]')
  } else {
    id = material.id
  }

  await authRequest.patch(
    '/materials/' + id,
    payload,
    { headers }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function delete_material(material_id){
  let data
  await authRequest.delete(
    '/materials/' + material_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function performS3Upload(file, onUploadProgressCallback) {
  try {
    const presignedUrlResponse = await getPresignedUrl(file.name, file.type);
    if (presignedUrlResponse.error) {
      throw new Error(presignedUrlResponse.result.error);
    }

    const { presigned_url, public_url, object_key } = presignedUrlResponse.result.data;

    const uploadResponse = await axios.put(presigned_url, file, {
      headers: {
        'Content-Type': file.type,
      },
      onUploadProgress: (progressEvent) => {
        if (onUploadProgressCallback) {
          onUploadProgressCallback(progressEvent);
        }
      },
    });

    const checksum = uploadResponse.headers.etag ? uploadResponse.headers.etag.replace(/"/g, '') : null;

    return {
      publicUrl: public_url,
      key: object_key,
      byteSize: file.size,
      checksum: checksum,
      filename: file.name,
      contentType: file.type
    };
  } catch (error) {
    console.error("S3 upload error:", error);
    swalError(`Failed to upload ${file.name}: ${error.message || error}`);
    throw error;
  }
}
